<template>
    <div class="text-center ma-2">
        <v-snackbar
            v-model="show"
            :color="type"
            :multi-line="mode === 'multi-line'"
            :timeout="timeout"
            :top="position === 'top'"
        >
            <v-layout align-center pr-4>
                <v-icon class="pr-3" dark large>{{ "error" }}</v-icon>
                <v-layout column>
                    <div>
                        <strong>{{ title }}</strong>
                    </div>
                    <div>{{ message }}</div>
                </v-layout>
            </v-layout>
            <v-btn v-if="timeout === -1" icon @click="show = false">
                <v-icon>clear</v-icon>
            </v-btn>
        </v-snackbar>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Boolean,
            required: true,
        },
        title: {
            type: String,
            default: "",
        },
        message: {
            type: String,
        },
        type: {
            type: String,
            default: "error",
        },
    },
    data() {
        return {
            mode: "multi-line",
            position: "top",
            timeout: -1,
            show: false,
        };
    },
    methods: {
        closeModal() {
            this.$emit("input", !this.value);
        },
    },
    watch: {
        value: {
            handler: function (newValue, oldValue) {
                this.show = newValue;
                this.$emit("watch-show-value", newValue);
            },
            deep: true,
            immediate: true,
        },
        show: {
            handler: function (newValue, oldValue) {
                this.$emit("watch-show-value", newValue);
            },
            deep: true,
            immediate: true,
        },
    },

    mounted() {
        this.show = this.value;
    },
};
</script>
<style lang="scss">
.v-snack__content {
    display: flex;
    flex-direction: row;
}
</style>
